import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Client from 'src/models/AP/Client';
import _ from 'lodash';
import TsdiClient from 'src/models/AP/Client';
import './GenerateInvoicesDialog.css';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';
import { InvoiceGeneration } from '../models/InvoiceGeneration';

interface IGenerateInvoicesDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onCancel?: () => void;
    onGenerateInvoices?: (payload: InvoiceGeneration) => void;
    resetClientSearchOptions?: () => void;
    setClientSearchTerm?: (keyword: string) => void;
    incrementClients?: () => void;
    clients?: Client[];
    showAddVendorDialog?: () => void;
    setSelectedClient?: (clientNumber: TsdiClient) => void;
    style?: React.CSSProperties;
    addNewClient?: boolean;
    defaultClient?: number;
    mileageRate?: number;
    offices?: Array<{value: number | string, label: string}>;
    periodTypes?: { code: number, description: string}[];
    currentUser?: number | null;
    payPeriod?: string | null;
}

const GenerateInvoicesDialog = (props: IGenerateInvoicesDialogProps) => {
    const { register, errors, getValues, handleSubmit, setValue } = useForm();
    const [clientBopRate, setclientBopRate] = useState<number>(250.00);
    // const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
}, []);

    useEffect(() => {
        if (Array.isArray(props?.clients) && props.clients.length > 0 && props.clients[0].backupOfficeRate) {
            setclientBopRate(Number(props.clients[0].backupOfficeRate.toFixed(4)));
        }
    }, [props?.clients]);

    useEffect(() => {
        if (clientBopRate) {
            setValue('generateInvoices.bopRate', clientBopRate);
        }
    }, [clientBopRate]);

    const onCreate = () => {
        // Initialization here
    };

    const onCancel = () => {
        props.hideDialog();
    };

    const periodTypeDropdownOptions = () => {
        return props?.periodTypes
            ? props?.periodTypes?.map((it: { code: number, description: string}) => {
                return { value: it.code, label: it?.description };
            })
            : [];
    };

    const officeDropdownOptions = () => {
        return !!props?.offices && props?.offices?.length > 0 ? props.offices : [
            { value: '1', label: 'OK' },
            { value: '2', label: 'TX' },
            { value: '3', label: 'IH' }
        ];
    };

    const onGenerateInvoices = (data: Invoice) => {
        console.log(data);
        const payload = getValues();
        const office = payload?.generateInvoices?.office ? props.offices.find(o => o.value === payload.generateInvoices.office)?.label : 'ALL';
        const transformedPayload = new InvoiceGeneration();
        transformedPayload.periodType = payload.generateInvoices.periodType;
        transformedPayload.backupRate = !isNaN(Number(payload.generateInvoices.bopRate)) ? Number(payload.generateInvoices.bopRate) : 250.00;
        transformedPayload.office = office ? office : 'OK';
        transformedPayload.startDate = payload.generateInvoices.beginDate;
        transformedPayload.endDate = payload.generateInvoices.endDate;
        transformedPayload.clientNumber = !!payload?.generateInvoices.clientNumber ? payload?.generateInvoices.clientNumber : '0';
        transformedPayload.projectNumber = !!payload?.generateInvoices.projectNumber ? payload?.generateInvoices.projectNumber : '0';
        transformedPayload.subcode = !!payload?.generateInvoices.subCode ? payload?.generateInvoices.subCode : '0';
        transformedPayload.altSubcode = !!payload?.generateInvoices.altSubcode ? payload?.generateInvoices.altSubcode : '0';
        transformedPayload.assignedBackup = payload?.generateInvoices.buAssignee;
        transformedPayload.invoiceDate = !!payload?.generateInvoices.invoiceDate ? payload.generateInvoices.invoiceDate : new Date().toISOString().split('T')[0];

        props.onGenerateInvoices(transformedPayload);
    };

    // Returns either the begin or end date of a pay period
    const getPayPeriodDate = (payPeriod: string, isBeginDate: boolean): string => {
        const [yearStr, periodStr] = payPeriod.split('-');
        const year = parseInt(yearStr, 10);
        const period = parseInt(periodStr, 10);

        if (isNaN(year) || isNaN(period) || period < 1 || period > 24) {
            throw new Error(`Invalid pay period: ${payPeriod}`);
        }

        // Determine month and day range based on the pay period number
        // Each month has 2 periods: 01–02 = Jan, 03–04 = Feb, etc.
        const month = Math.ceil(period / 2); // 1–12

        let day: number;

        if (period % 2 === 1) {
            // Odd = 1st half: 1st to 15th
            day = isBeginDate ? 1 : 15;
        } else {
            // Even = 2nd half: 16th to end of month
            const lastDay = new Date(year, month, 0).getDate(); // 0th day of next month = last day of this month
            day = isBeginDate ? 16 : lastDay;
        }

        return new Date(year, month - 1, day).toISOString().split('T')[0];
    };

    return (
        <>
        <Dialog title={'Generate Invoices'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '50vh', width: '35%' }}>
        <form id={'createClientForm'} onSubmit={handleSubmit(onGenerateInvoices)}>
            <div style={{display: 'inline-block', marginTop: '1rem'}}>
                <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
                    <RHFSelect
                        bodyStyle={{marginBottom: '5px', whiteSpace: 'nowrap', width: '90%' }}
                        style={{whiteSpace: 'nowrap', width: '100%' }}
                        name={`generateInvoices.periodType`}
                        label="Period Type:"
                        options={periodTypeDropdownOptions()}
                        register={register}
                        defaultVal={'2'}
                        errors={errors}
                        rules={{ required: 'Period Type required' }}
                        isRequired={true}
                    />
                    <RHFSelect
                        bodyStyle={{marginBottom: '5px', whiteSpace: 'nowrap', width: '90%' }}
                        style={{whiteSpace: 'nowrap', width: '100%' }}
                        name={`generateInvoices.office`}
                        label="Office:"
                        options={officeDropdownOptions()}
                        register={register}
                        defaultVal={'L'}
                        errors={errors}
                        rules={{ required: 'Office required' }}
                        isRequired={true}
                    />
                </div>
                <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
                    <RHFInputBox
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        label="Start Date"
                        labelOnLeft={true}
                        defaultVal={!!props?.payPeriod && getPayPeriodDate(props?.payPeriod, true)}
                        name={`generateInvoices.beginDate`}
                        type="date"
                        register={register}
                        rules={{ required: 'Start Date required' }}
                        errors={errors}
                        isRequired={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '62%' }}
                    />
                    <RHFInputBox
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        label="End Date"
                        labelOnLeft={true}
                        defaultVal={!!props?.payPeriod && getPayPeriodDate(props?.payPeriod, false)}
                        name={`generateInvoices.endDate`}
                        type="date"
                        register={register}
                        rules={{ required: 'End Date required' }}
                        errors={errors}
                        isRequired={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '62%' }}
                        onChange={(e) => {
                            setValue('generateInvoices.invoiceDate', e.currentTarget.value);
                        }}
                    />
                </div>
                <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Client Number:'}
                        labelOnLeft={true}
                        name={'generateInvoices.clientNumber'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        errors={errors}
                        onBlur={(e) => props?.setClientSearchTerm(e.currentTarget.value)}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'BOP Rate:'}
                        labelOnLeft={true}
                        defaultVal={clientBopRate ? clientBopRate.toString() : ''}
                        name={'generateInvoices.bopRate'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        rules={{ required: 'BOP Rate required' }}
                        isRequired={true}
                        errors={errors}
                    />
                </div>
                <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Project Number:'}
                        labelOnLeft={true}
                        name={'generateInvoices.projectNumber'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Assign Backup Time:'}
                        defaultVal={!!props?.currentUser ? props.currentUser.toString() : '5502'}
                        labelOnLeft={true}
                        name={'generateInvoices.buAssignee'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        isRequired={true}
                        rules={{ required: 'Backup assignee is required' }}
                        errors={errors}
                    />
                </div>
                <div style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        label={'Subcode:'}
                        labelOnLeft={true}
                        name={'generateInvoices.subcode'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                        errors={errors}
                    />
                    <RHFInputBox
                        bodyClassName={'project-billing form-group'}
                        defaultVal={new Date().toISOString().split('T')[0]}
                        type={'date'}
                        label={'Invoice Date:'}
                        labelOnLeft={true}
                        name={'generateInvoices.invoiceDate'}
                        style={{whiteSpace: 'nowrap', width: '50%'}}
                        bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                        register={register}
                    />
                </div>
                <RHFInputBox
                    bodyClassName={'project-billing form-group'}
                    label={'Alt Subcode:'}
                    labelOnLeft={true}
                    name={'generateInvoices.altSubcode'}
                    style={{whiteSpace: 'nowrap', width: '50%'}}
                    bodyStyle={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', width: '55%'}}
                    register={register}
                    errors={errors}
                />
            </div>
                <div className="project-billing form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                {!props.addNewClient && <Button
                    className="blue-hover-button"
                    type={'submit'}
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Generate'}
                />}
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => onCancel()}
                />
                </div>
            </form>

        </Dialog>
        </>
    );
};

export default GenerateInvoicesDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateInvoicesDialog.tsx